import { createStore, createTypedHooks } from 'easy-peasy';

import { AppModel, appModel } from '~/app/store';
import { TenantModel, tenantModel } from '~/tenantProvider/store';
import { FormModel, formModel } from '~/app/modules/form/store';
import { UserModel, userModel } from '~/user/store';
import { ProjectsModel, projectsModel } from '~/projects/store/index';
import { ProjectModel, projectModel } from '~/projects/store/project';
import { MachinesModel, machinesModel } from '~/machines/store/index';
import { MachineModel, machineModel } from '~/machines/store/machine';
import { IssueModel, issueModel } from '~/issues/store';
import { PeriodicCheckModel, periodicCheckModel } from '~/periodicCheck/store';
import { DocumentationModel, documentationModel } from '~/documentation/store';
import { MsalBrowserModel, msalBrowserModel } from '~/auth/store/msalBrowser';
import { chatModel, ChatModel, NotificationModel, notificationModel } from '~/notifications/store';
import { tasksModel, TasksModel } from '~/tasks/store';
import { serviceModel, ServiceModel } from '~/services/store';
import { timeManagementModel, TimeManagementModel } from '~/timeManagement/store';
import { serviceCheckModel, ServiceCheckModel } from '~/services/Details/ServiceChecklist/store';
import { trainingModel, TrainingModel } from '~/training/store';
import { communicationChatModel, CommunicationChatModel } from '~/communication/chatStore';
import { communicationModel, CommunicationModel } from '~/communication/store';
import { workOrderModel, WorkOrderModel } from '~/workorder/store';
import { registerConnectivityStoreBridge } from '~/data/connectivity/connectivityStoreBridge';

export interface StoreModel {
  app: AppModel
  tenant: TenantModel
  form: FormModel
  user: UserModel
  projects: ProjectsModel
  project: ProjectModel
  machines: MachinesModel
  machine: MachineModel
  issue: IssueModel
  periodicCheck: PeriodicCheckModel
  documentation: DocumentationModel
  msalBrowser: MsalBrowserModel
  notification: NotificationModel,
  tasks: TasksModel,
  service: ServiceModel,
  timeManagement: TimeManagementModel,
  serviceCheck: ServiceCheckModel,
  chat: ChatModel,
  training: TrainingModel,
  communicationChat: CommunicationChatModel,
  communication: CommunicationModel,
  workOrder: WorkOrderModel,
}

const storeModel: StoreModel = {
  app: appModel,
  tenant: tenantModel,
  form: formModel,
  user: userModel,
  projects: projectsModel,
  project: projectModel,
  machines: machinesModel,
  machine: machineModel,
  issue: issueModel,
  periodicCheck: periodicCheckModel,
  documentation: documentationModel,
  msalBrowser: msalBrowserModel,
  chat: chatModel,
  notification: notificationModel,
  tasks: tasksModel,
  service: serviceModel,
  serviceCheck: serviceCheckModel,
  training: trainingModel,
  timeManagement: timeManagementModel,
  communicationChat: communicationChatModel,
  communication: communicationModel,
  workOrder: workOrderModel,
};

const typedHooks = createTypedHooks<StoreModel>();

export const { useStoreState } = typedHooks;
export const { useStoreActions } = typedHooks;

const store = createStore<StoreModel>(storeModel, {
  name: 'TRANSPORT',
});

registerConnectivityStoreBridge(() => {
  store.getActions().app.offline._updateState();
});

export default store;
